// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__t8eww","label":"styles_label__WFa5V"};